module.exports = __webpack_public_path__ + "media/sfx_point.5a6c267d.wav";